import React from 'react'
import Layouts from '../../Layouts/Layouts'
import { StyledMainPageRightSection } from '../dashboard/style.dashboard'

const VisaServices = () => {
  return (
    <>
      <Layouts>

        <StyledMainPageRightSection>
        <h1>ON Visa services</h1>
        </StyledMainPageRightSection>
      
      </Layouts>
    </>
  )
}

export default VisaServices
